import { platform } from '@/platform'

/* Spec PWA-001 — tela 01: o onboarding aparece so no primeiro uso do aparelho. */

const ONBOARDING_KEY = 'gpd-onboarding-done'

export function isOnboardingDone(): boolean {
    return platform.storage.get(ONBOARDING_KEY) === '1'
}

export function markOnboardingDone(): void {
    platform.storage.set(ONBOARDING_KEY, '1')
}
